import { ChevronDown } from 'lucide-react';
import { forwardRef } from 'react';
import type { SelectHTMLAttributes } from 'react';
import type { LucideIcon } from 'lucide-react';

interface Option {
  value: string | number;
  label: string;
}

interface PesageSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  icon?: LucideIcon;
  label?: string;
  placeholder?: string;
  options: Option[];
  error?: string;
}

export const PesageSelect = forwardRef<HTMLSelectElement, PesageSelectProps>(
  ({ icon: Icon, label, placeholder, options, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm text-pesage-secondary mb-1.5">
            {label}
          </label>
        )}
        <div className="relative">
          {Icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-pesage-muted pointer-events-none">
              <Icon className="w-4 h-4" />
            </div>
          )}
          <select
            ref={ref}
            className={`h-10 w-full appearance-none rounded-md border border-pesage-border bg-pesage-bg px-3 pr-10 text-sm text-pesage-primary transition-colors focus:border-pesage-green focus:ring-1 focus:ring-pesage-green ${
              Icon ? 'pl-9' : 'pl-3'
            } ${error ? 'border-pesage-red focus:ring-pesage-red focus:border-pesage-red' : ''} ${className}`}
            {...props}
          >
            {placeholder && (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-pesage-muted pointer-events-none">
            <ChevronDown className="h-4 w-4" />
          </div>
        </div>
        {error && <p className="text-pesage-red text-xs mt-1">{error}</p>}
      </div>
    );
  }
);

PesageSelect.displayName = 'PesageSelect';
